// builders/EnclosurePlacementSaver.js
import api from "../api/axios";

export async function saveFullEnclosurePlacement(projectId, enclosure) {
  // Save enclosure base
  await api.put(`/project/${projectId}/enclosure`, enclosure);
}

export async function updateEnclosurePlacementWithFieldsAsync(
  projectId,
  fields,
) {
  // Get Latest Project
  const latestProject = await api
    .get(`/projects/${projectId}/enclosure`)
    .catch(() => null);
  if (latestProject == null) return null;

  // Check if EnclosurePlacement is not null
  if (latestProject?.enclosurePlacement == null) return null;

  const merged = {
    ...latestProject.enclosurePlacement,
    ...fields,
  };


  try {
    await saveFullEnclosurePlacement(projectId, merged);
    return {
      ...latestProject,
      enclosurePlacement: merged,
    };
  } catch (err) {
    console.error("Failed to update enclosure:", err);
    return null;
  }
}
